const SELECTOR = '.has-clip-path';

function onDocumentReady() {
    const els = document.querySelectorAll(SELECTOR);

    if (!els) {
        return;
    }

    els.forEach(el => injectOverlay(el));
}

function injectOverlay(el) {
	const path = el.querySelectorAll('.clip-path-overlay');

	if (path && path > 0) {
		return;
	}

	const clipPath = document.createElement('div');
	clipPath.className = 'clip-path-overlay';

	const column = el.querySelector('.wp-block-column'); // just the first column

	if (column) {
		clipPath.style.setProperty('--mobile-height', column.offsetHeight +  'px');
	}

	el.appendChild(clipPath);

}

document.addEventListener('DOMContentLoaded', onDocumentReady);